export function schoolTermListAllQuery() {
  const query =
    '{schoolTermListAll{id, name, year, initialDate, finalDate, status}}';
  return query;
}

export function schoolTermListIdAndName() {
  const query = '{schoolTermListAll{id, name}}';
  return query;
}

export function schoolTermFindByIdQuery(id) {
  const query = `{schoolTermFindById(id: ${id}){id, name, year, initialDate, finalDate, status}}`;
  return query;
}

export function saveSchoolTermMutation(values) {
  const mutationQuery = `mutation {
    schoolTermSave(
      schoolTerm: {
                id: ${values.id},
                name: "${values.name}",
                year: ${values.year.getFullYear()},
                initialDate: ${values.initialDate.getTime()},
                finalDate: ${values.finalDate.getTime()},
                status: "${values.status.value}",
                updaterId: 0,
                filterByStatus: false,
            }),
        {id}
    }`;
  return mutationQuery;
}

export function removeSchoolTermMutation(id) {
  const query = `mutation {schoolTermRemove(id: ${id})}`;
  return query;
}
